// import axios from 'axios'
// import config from 'config/web/config'

// Not used yet at least

export default async function validatePassword(value: string) {
    // console.log('TCL: validatePassword -> value', value)
}
